export const UMB_THEME_LIGHT_ALIAS = 'umb-light-theme';
export const UMB_THEME_DARK_ALIAS = 'umb-dark-theme';
export const UMB_THEME_HIGH_CONTRAST_ALIAS = 'umb-high-contrast-theme';
